import { Component, Inject, Input } from '@angular/core';

import { Router } from '@angular/router';

import { EnvironmentConfig } from '../../../config/environment.config';

@Component({
  selector: 'mom-header-with-logo-and-timer',
  templateUrl: './header-with-logo-and-timer.component.html',
  styleUrls: ['./header-with-logo-and-timer.component.scss']
})
export class HeaderWithLogoAndTimerComponent {
  @Input() countdown: { warning: boolean; timer: string };
  @Input() showLogo = true;

  logo = this.environment.logoPath;
  logoAltName = `${this.environment.appName} Logo`;

  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private router: Router
  ) {}

  goHome(): void {
    this.router.navigate(['home']);
  }
}
